// @ts-nocheck

import { executeRequest, Request } from '@jfs/network'
import axios from 'axios'
import { CardType } from '../../data/models/Card'
import { errorMessage } from '../../utils/string'
import { getAPIURL, getMMSHeader } from '../config'

const responseParser = (response: any, merchantId: string) => {
  // response = [
  //   {
  //     emi: {
  //       bank: '1',
  //       bankName: 'HDFC Bank',
  //       bankImageUrl: 'bankLogo Url',
  //       termsAndConditions: 'Bank T&C',
  //       scheme: '11_1684',
  //       tenure: '3M',
  //       schemeType: '02',
  //       schemeSubType: '00',
  //       value: 3706.52,
  //       interestRate: 13,
  //       interest: 236.61,
  //       discount: '117.05',
  //       cashBack: '0',
  //       schemeNote: 'To be fetched by Retrieve API',
  //       metadata: 'Other details from pinelabs (Free text JSON)',
  //     },
  //     amount: {
  //       grossAmount: '10000.00',
  //       netAmount: '10882.95',
  //     },
  //     product: [
  //       {
  //         productId: 'SMG975FCWG',
  //         productAmount: '5500.0',
  //         emiPlan: {
  //           scheme: '1682',
  //           programType: '112',
  //           subventionCashbackDiscount: '117.05',
  //           productDiscount: '0',
  //           subventionCashbackDiscountPercentage: '21.5',
  //           productDiscountPercentage: '0',
  //           allowZeroCost: '01',
  //           metadata: 'Other product details from pinelabs (Free text JSON)',
  //         },
  //       },
  //       {
  //         productId: 'SMG975FCKG',
  //         productAmount: '5000.0',
  //         emiPlan: {
  //           scheme: '1683',
  //           programType: '112',
  //           productId: 'SMG9757CXH',
  //           productAmount: '5000.0',
  //           subventionCashbackDiscount: '110.0',
  //           productDiscount: '0',
  //           subventionCashbackDiscountPercentage: '21.0',
  //           productDiscountPercentage: '0',
  //           allowZeroCost: '01',
  //           metadata: 'Other product details from pinelabs (Free text JSON)',
  //         },
  //       },
  //     ],
  //     processingFees: {
  //       type: 'P',
  //       value: '5.0',
  //       amount: '500.00',
  //       tax: '18.00', //Tax in RS.Ps
  //       taxPercentage: '18', //Percentage of Tax
  //     },
  //     convenienceFees: {
  //       type: 'F',
  //       value: '100.0',
  //       amount: '100.00',
  //       tax: '18.00', //Tax in RS.Ps
  //       taxPercentage: '18.00', //Percentage of Tax
  //     },
  //   },
  //   {
  //     emi: {
  //       bank: '1',
  //       bankName: 'HDFC Bank',
  //       bankImageUrl: 'bankLogo Url',
  //       termsAndConditions: 'Bank T&C',
  //       scheme: '11_1684',
  //       tenure: '3M',
  //       schemeType: '01',
  //       schemeSubType: '00',
  //       value: 3906.52,
  //       interestRate: 13,
  //       interest: 236.61,
  //       discount: '0',
  //       cashBack: '0',
  //       schemeNote: 'To be fetched by Retrieve API',
  //       metadata: 'Other details from pinelabs (Free text JSON)',
  //     },
  //     amount: {
  //       grossAmount: '10000.00',
  //       netAmount: '10882.95',
  //     },
  //     product: [
  //       {
  //         productId: 'SMG975FCNG',
  //         productAmount: '5500.0',
  //         emiPlan: {
  //           scheme: '1682',
  //           programType: '112',
  //           subventionCashbackDiscount: '117.05',
  //           productDiscount: '0',
  //           subventionCashbackDiscountPercentage: '21.5',
  //           productDiscountPercentage: '0',
  //           allowZeroCost: '01',
  //           metadata: 'Other product details from pinelabs (Free text JSON)',
  //         },
  //       },
  //       {
  //         productId: 'SMG975FCKG',
  //         productAmount: '5000.0',
  //         emiPlan: {
  //           scheme: '1683',
  //           programType: '112',
  //           productId: 'SMG9757CXH',
  //           productAmount: '5000.0',
  //           subventionCashbackDiscount: '110.0',
  //           productDiscount: '0',
  //           subventionCashbackDiscountPercentage: '21.0',
  //           productDiscountPercentage: '0',
  //           allowZeroCost: '00',
  //           metadata: 'Other product details from pinelabs (Free text JSON)',
  //         },
  //       },
  //     ],
  //     processingFees: {
  //       type: 'P',
  //       value: '5.0',
  //       amount: '500.00',
  //       tax: '18.00', //Tax in RS.Ps
  //       taxPercentage: '18', //Percentage of Tax
  //     },
  //     convenienceFees: {
  //       type: 'F',
  //       value: '100.0',
  //       amount: '100.00',
  //       tax: '18.00', //Tax in RS.Ps
  //       taxPercentage: '18.00', //Percentage of Tax
  //     },
  //   },
  //   {
  //     emi: {
  //       bank: '1',
  //       bankName: 'HDFC Bank',
  //       bankImageUrl: 'bankLogo Url',
  //       termsAndConditions: 'Bank T&C',
  //       scheme: '11_1684',
  //       tenure: '3M',
  //       schemeType: '01',
  //       schemeSubType: '00',
  //       value: 3906.52,
  //       interestRate: 13,
  //       interest: 236.61,
  //       discount: '1700',
  //       cashBack: '0',
  //       schemeNote: 'To be fetched by Retrieve API',
  //       metadata: 'Other details from pinelabs (Free text JSON)',
  //     },
  //     amount: {
  //       grossAmount: '10000.00',
  //       netAmount: '10882.95',
  //     },
  //     product: [
  //       {
  //         productId: 'SMG975FCNG',
  //         productAmount: '5500.0',
  //         emiPlan: {
  //           scheme: '1682',
  //           programType: '112',
  //           subventionCashbackDiscount: '117.05',
  //           productDiscount: '0',
  //           subventionCashbackDiscountPercentage: '21.5',
  //           productDiscountPercentage: '0',
  //           allowZeroCost: '01',
  //           metadata: 'Other product details from pinelabs (Free text JSON)',
  //         },
  //       },
  //       {
  //         productId: 'SMG975FCKG',
  //         productAmount: '5000.0',
  //         emiPlan: {
  //           scheme: '1683',
  //           programType: '112',
  //           productId: 'SMG9757CXH',
  //           productAmount: '5000.0',
  //           subventionCashbackDiscount: '110.0',
  //           productDiscount: '0',
  //           subventionCashbackDiscountPercentage: '21.0',
  //           productDiscountPercentage: '0',
  //           allowZeroCost: '00',
  //           metadata: 'Other product details from pinelabs (Free text JSON)',
  //         },
  //       },
  //     ],
  //     processingFees: {
  //       type: 'P',
  //       value: '5.0',
  //       amount: '500.00',
  //       tax: '18.00', //Tax in RS.Ps
  //       taxPercentage: '18', //Percentage of Tax
  //     },
  //     convenienceFees: {
  //       type: 'F',
  //       value: '100.0',
  //       amount: '100.00',
  //       tax: '18.00', //Tax in RS.Ps
  //       taxPercentage: '18.00', //Percentage of Tax
  //     },
  //   },
  //   {
  //     emi: {
  //       bank: '1',
  //       bankName: 'HDFC Bank',
  //       bankImageUrl: 'bankLogo Url',
  //       termsAndConditions: 'Bank T&C',
  //       scheme: '11_1684',
  //       tenure: '3M',
  //       schemeType: '02',
  //       schemeSubType: '00',
  //       value: 3806.52,
  //       interestRate: 13,
  //       interest: 236.61,
  //       discount: '117.05',
  //       cashBack: '0',
  //       schemeNote: 'To be fetched by Retrieve API',
  //       metadata: 'Other details from pinelabs (Free text JSON)',
  //     },
  //     amount: {
  //       grossAmount: '10000.00',
  //       netAmount: '10882.95',
  //     },
  //     product: [
  //       {
  //         productId: 'SMG975FCEG',
  //         productAmount: '5500.0',
  //         emiPlan: {
  //           scheme: '1682',
  //           programType: '112',
  //           subventionCashbackDiscount: '117.05',
  //           productDiscount: '0',
  //           subventionCashbackDiscountPercentage: '21.5',
  //           productDiscountPercentage: '0',
  //           allowZeroCost: '03',
  //           metadata: 'Other product details from pinelabs (Free text JSON)',
  //         },
  //       },
  //       {
  //         productId: 'SMG975FCLG',
  //         productAmount: '5000.0',
  //         emiPlan: {
  //           scheme: '1683',
  //           programType: '112',
  //           productId: 'SMG9757CXH',
  //           productAmount: '5000.0',
  //           subventionCashbackDiscount: '110.0',
  //           productDiscount: '0',
  //           subventionCashbackDiscountPercentage: '21.0',
  //           productDiscountPercentage: '0',
  //           allowZeroCost: '03',
  //           metadata: 'Other product details from pinelabs (Free text JSON)',
  //         },
  //       },
  //     ],
  //     processingFees: {
  //       type: 'P',
  //       value: '5.0',
  //       amount: '500.00',
  //       tax: '18.00', //Tax in RS.Ps
  //       taxPercentage: '18', //Percentage of Tax
  //     },
  //     convenienceFees: {
  //       type: 'F',
  //       value: '100.0',
  //       amount: '100.00',
  //       tax: '18.00', //Tax in RS.Ps
  //       taxPercentage: '18.00', //Percentage of Tax
  //     },
  //   },
  //   {
  //     emi: {
  //       bank: '1',
  //       bankName: 'HDFC Bank',
  //       bankImageUrl: 'bankLogo Url',
  //       termsAndConditions: 'Bank T&C',
  //       scheme: '11_1684',
  //       tenure: '3M',
  //       schemeType: '02',
  //       schemeSubType: '00',
  //       value: 4106.52,
  //       interestRate: 13,
  //       interest: 236.61,
  //       discount: '117.05',
  //       cashBack: '0',
  //       schemeNote: 'To be fetched by Retrieve API',
  //       metadata: 'Other details from pinelabs (Free text JSON)',
  //     },
  //     amount: {
  //       grossAmount: '10000.00',
  //       netAmount: '10882.95',
  //     },
  //     product: [
  //       {
  //         productId: 'SMG975FCEG',
  //         productAmount: '5500.0',
  //         emiPlan: {
  //           scheme: '1682',
  //           programType: '112',
  //           subventionCashbackDiscount: '117.05',
  //           productDiscount: '0',
  //           subventionCashbackDiscountPercentage: '21.5',
  //           productDiscountPercentage: '0',
  //           allowZeroCost: '02',
  //           metadata: 'Other product details from pinelabs (Free text JSON)',
  //         },
  //       },
  //       {
  //         productId: 'SMG975FCLG',
  //         productAmount: '5000.0',
  //         emiPlan: {
  //           scheme: '1683',
  //           programType: '112',
  //           productId: 'SMG9757CXH',
  //           productAmount: '5000.0',
  //           subventionCashbackDiscount: '110.0',
  //           productDiscount: '0',
  //           subventionCashbackDiscountPercentage: '21.0',
  //           productDiscountPercentage: '0',
  //           allowZeroCost: '03',
  //           metadata: 'Other product details from pinelabs (Free text JSON)',
  //         },
  //       },
  //     ],
  //     processingFees: {
  //       type: 'P',
  //       value: '5.0',
  //       amount: '500.00',
  //       tax: '18.00', //Tax in RS.Ps
  //       taxPercentage: '18', //Percentage of Tax
  //     },
  //     convenienceFees: {
  //       type: 'F',
  //       value: '100.0',
  //       amount: '100.00',
  //       tax: '18.00', //Tax in RS.Ps
  //       taxPercentage: '18.00', //Percentage of Tax
  //     },
  //   },
  // ]
  const retData = response.map((item: any) => ({
    merchantId: merchantId || '',
    bank: item?.emi?.bank || '',
    bankName: item?.emi?.bankName || '',
    allowZeroCost: item?.emi?.allowZeroCost || '',
    bankImageUrl: item?.emi?.bankImageUrl || '',
    termsAndConditions: item?.emi?.termsAndConditions || '',
    scheme: item?.emi?.scheme || '',
    tenure: item?.emi?.tenure || '',
    schemeType: item?.emi?.schemeType || '',
    schemeSubType: item?.emi?.schemeSubType || '',
    value: String(item?.emi?.value) || '',
    interestRate: String(item?.emi?.interestRate) || '',
    interest: String(item?.emi?.interest) || '',
    discount: item?.emi?.discount || '',
    cashBack: item?.emi?.cashBack || '',
    schemeNote: item?.emi?.schemeNote || '',
    planSource: item?.emi?.planSource || '0',
    processingMethod: item?.emi?.processingMethod || '',
    metadata: JSON.stringify(item?.emi?.metadata) || '',
    grossAmount: item?.amount?.grossAmount || '',
    netAmount: item?.amount?.netAmount || '',
    totalAmount: item?.amount?.totalAmount || '',
    processingFees: {
      type: item?.processingFees?.type,
      value: item?.processingFees?.value || '',
      amount: item?.processingFees?.amount,
      tax: item?.processingFees?.tax,
      taxPercentage: item?.processingFees?.taxpercentage,
    },
    convenienceFees: {
      type: item?.convenienceFees?.type,
      value: item?.convenienceFees?.value || '',
      amount: item?.convenienceFees?.amount,
      tax: item?.convenienceFees?.tax,
      taxPercentage: item?.convenienceFees?.taxpercentage,
    },
    product: item?.product || [],

    // allowZeroCost: item?.allowZeroCost || '',
    // amount: item?.amount || '',
    // brand: item?.brand || '',
    // emi: item?.emi || '',
    // productsList: item?.productSkuList || [],
    // totalFee: item?.totalFee || '',
    // processingFee: {
    //   feeAddtnTaxAmount: item?.processingFees?.feeAddtnTaxAmount || '',
    //   feeAddtnTaxPercent: item?.processingFees?.feeAddtnTaxPercent || '',
    //   feeAmount: item?.processingFees?.feeAmount || '',
    //   feeCgstAmount: item?.processingFees?.feeCgstAmount || '',
    //   feeCgstPercent: item?.processingFees?.feeCgstPercent || '',
    //   feeIgstAmount: item?.processingFees?.feeIgstAmount || '',
    //   feeIgstPercent: item?.processingFees?.feeIgstPercent || '',
    //   feeSgstAmount: item?.processingFees?.feeSgstAmount || '',
    //   feeSgstPercent: item?.processingFees?.feeSgstPercent || '',
    //   feeTotalGstAmount: item?.processingFees?.feeTotalGstAmount || '',
    //   feeTotalGstPercent: item?.processingFees?.feeTotalGstPercent || '',
    //   feeType: item?.processingFees?.feeType || '',
    //   feeUgstAmount: item?.processingFees?.feeUgstAmount || '',
    //   feeUgstPercent: item?.processingFees?.feeUgstPercent || '',
    // },
    // processingFeeTax: item?.processingFeeTax || '',
    // convenienceFee: {
    //   feeAddtnTaxAmount: item?.convenienceFees?.feeAddtnTaxAmount || '',
    //   feeAddtnTaxPercent: item?.convenienceFees?.feeAddtnTaxPercent || '',
    //   feeAmount: item?.convenienceFees?.feeAmount || '',
    //   feeCgstAmount: item?.convenienceFees?.feeCgstAmount || '',
    //   feeCgstPercent: item?.convenienceFees?.feeCgstPercent || '',
    //   feeIgstAmount: item?.convenienceFees?.feeIgstAmount || '',
    //   feeIgstPercent: item?.convenienceFees?.feeIgstPercent || '',
    //   feeSgstAmount: item?.convenienceFees?.feeSgstAmount || '',
    //   feeSgstPercent: item?.convenienceFees?.feeSgstPercent || '',
    //   feeTotalGstPercent: item?.convenienceFees?.feeTotalGstPercent || '',
    //   feeTotalGstAmount: item?.convenienceFees?.feeTotalGstAmount || '',
    //   feeType: item?.convenienceFees?.feeType || '',
    //   feeUgstAmount: item?.convenienceFees?.feeUgstAmount || '',
    //   feeUgstPercent: item?.convenienceFees?.feeUgstPercent || '',
    // },
    // convenienceFeeTax: item?.convenienceFeeTax || '',
    // interest: item?.interest || '',
    // interestRate: item?.interestRate || '',
    // processingMethod: item?.processingMethod || '',
    // minAmount: item?.minAmount || '',
    // maxAmount: item?.maxAmount || '',
    // startDate: item?.startDate || '',
    // endDate: item?.endDate || '',
    // totalAmount: item?.totalAmount || '',

    // schemeNote: item?.schemeNote || '',
    // cashBackAmount: item?.cashBackAmount || '',
  }))
  console.log('retData', retData)
  return retData
}

const parseCardsResponse = (response: any) => {
  const retData = response.map((item: any) => ({
    token: item.bin,
    emiBankId: item.emiBankId,
    isEMIEligible: item.isBinValid === 'Y' ? true : false,
  }))
  console.log('retData', retData)
  return retData
}

export const emiCardsEligibility = (deviceData: any, inputParams: any) => {
  const input = {
    ...inputParams,
  }

  const request: Request<{}> = {
    apiPath: getAPIURL('emiBinValidate'),
    method: 'POST',
    body: input,
    headers: {
      ...getMMSHeader(),
      'x-device-info': deviceData,
    },
  }

  return executeRequest(request)
    .then((data: any) => {
      return parseCardsResponse(data?.data?.response)
    })
    .catch((error) => {
      const customError = { message: error?.data?.error?.message, code: error?.data?.error?.code }
      console.log('customError', customError)
      throw customError
    })
}

export const emiRetrieveCards = async (deviceData: any, inputParams: any, userCards: [CardType]) => {
  const savedCards = []
  userCards.forEach(async (item) => {
    const response = await axios.post(
      getAPIURL('emiRetrieve'),
      {
        ...inputParams,
        filters: {
          token: item.token,
          cardBin: '43864242',
          amount: inputParams.filters.amount,
        },
      },
      {
        headers: {
          ...getMMSHeader(),
          'x-device-info': deviceData,
        },
      },
    )
    console.log('response?.data?.response?.status', response?.data?.status)
    if (response?.data?.status === 'SUCCESS') {
      const retData = response?.data?.response.map((item: any) => ({
        merchantId: item?.merchantId || '',
        emiBankId: item?.emiBankId || '',
        emiBankName: item?.emiBankName || '',
        emiBankImageUrl: item?.emiBankImageUrl || '',
        schemeId: item?.schemeId || '',
        tenureId: item?.tenureId || '',
        allowZeroCost: item?.allowZeroCost || '',
        amount: item?.amount || '',
        brand: item?.brand || '',
        emi: item?.emi || '',
        productsList: item?.productSkuList || [],
        totalFee: item?.totalFee || '',
        processingFee: item?.processingFee || '',
        processingFeeTax: item?.processingFeeTax || '',
        convenienceFee: item?.convenienceFee || '',
        convenienceFeeTax: item?.convenienceFeeTax || '',
        interest: item?.interest || '',
        interestRate: item?.interestRate || '',
        processingMethod: item?.processingMethod || '',
        minAmount: item?.minAmount || '',
        maxAmount: item?.maxAmount || '',
        startDate: item?.startDate || '',
        endDate: item?.endDate || '',
        schemeSubType: item?.schemeSubType || '',
        cashBackAmount: item?.cashBackAmount || '',
      }))
      console.log('EMI response', retData, item)
      savedCards.push(item)
      // item.EMILList = retData
    } else {
      const error = {
        data: {
          message: response?.data?.error?.message ?? errorMessage.defautCatchMessage,
          errorCode: response?.data?.error?.code,
        },
      }
      throw error
    }
  })
}

export const emiRetrieve = (deviceData: any, inputParams: any) => {
  const input = {
    ...inputParams,
  }

  const request: Request<{}> = {
    //apiPath: `http://10.140.138.12:3009/jfs/v2/emi/merchant/retrieve`,
    apiPath: getAPIURL('emiRetrieve'),
    method: 'POST',
    body: input,
    headers: {
      ...getMMSHeader(),
      //'x-channel-id': '3133',
      'x-device-info': deviceData,
    },
  }

  return executeRequest(request)
    .then((data: any) => {
      if (data?.data?.status === 'SUCCESS') {
        return responseParser(data?.data?.response, data?.data?.merchantId)
      } else {
        const error = {
          data: {
            message: data?.data?.error?.message ?? errorMessage.defautCatchMessage,
            errorCode: data?.data?.error?.code,
          },
        }
        throw error
      }
    })
    .catch((error) => {
      const customError = { message: error?.data?.message, code: error?.data?.errorCode }
      throw customError
    })
}

// export const EMIList = (
//   baseURL: string,
//   deviceInfo: any,
//   accessToken: string,
//   appIdToken: string,
//   merchantID: number,
//   inputParams: any,
// ) => {
//   console.log('baseURL', baseURL, deviceInfo, accessToken, appIdToken)
//   const input = {
//     merchantId: merchantID,
//     filters: {
//       ...inputParams,
//     },
//   }

//   var deviceData = JSON.stringify(deviceInfo)

//   const request: Request<{}> = {
//     apiPath: getAPIURL(baseURL, 'EMIRetrieve'),
//     method: 'POST',
//     body: input,
//     headers: {
//       ...getPaymentHeader(),
//       'x-device-info': deviceData,
//       'x-app-access-token': accessToken,
//       'x-appid-token': appIdToken,
//     },
//   }

//   return executeRequest(request)
//     .then((data: any) => {
//       if (data?.data?.status === 'SUCCESS') {
//         return responseParser(data?.data?.response)
//       } else {
//         console.log('1')
//         const error = data?.data?.error?.message
//         console.log('2', error)
//         throw error
//       }
//     })
//     .catch((error) => {
//       throw error
//     })
// }
